<script setup lang="ts">
const { variant = 'primary', asAnchor } = defineProps<{ variant?: 'primary' | 'secondary'; asAnchor?: boolean }>()
</script>

<template>
  <a v-if="asAnchor" class="button" :class="variant">
    <slot />
  </a>
  <button v-else class="button" :class="variant">
    <slot />
  </button>
</template>

<style lang="scss" scoped>
.button {
  padding: 8px 16px;
  font-size: 16px;
  font-weight: bold;
  border: none;
  border-radius: 999px;
  cursor: pointer;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 8px;
  text-decoration: none;
  white-space: nowrap;

  &:disabled {
    background-color: var(--background-subtle);
    cursor: not-allowed;
  }
}

.primary {
  background-color: var(--primary);
}
.secondary {
  background-color: var(--secondary);
}
</style>
